<template>
    <el-dialog
        title="供应商调用"
        :visible.sync="disableDialog"
        width="1000px">
        <el-form>
            <el-row :gutter="10">
                <el-col :span="6">
                    <el-form-item label="查询项：" label-width="60px">
                        <el-select v-model="params.column">
                            <el-option v-for="(item,index) in waitFeedbackEnquiryList"
                            :key="index"
                            :label="item.label"
                            :value="item.value"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item>
                        <el-input v-model="params.value" placeholder="请输入关键词"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item>
                        <el-button @click="searchFor" type="primary">搜索</el-button>
                        <el-button @click="searchReset" type="">重置</el-button>
                    </el-form-item>
                </el-col>
                <!-- <el-col :span="6" style="text-align:right;">
                    <el-form-item>
                        <el-button @click="onAddSupplier" type="primary" plain>添加供应商</el-button>
                    </el-form-item>
                </el-col> -->
            </el-row>
        </el-form>
        <el-table
            border
            ref="tableRef"
            :data="list"
            height="478"
            tooltip-effect="dark"
            highlight-current-row
            @current-change="handleCurrentChange"
            v-el-table-loadmore="loadmore"
            :header-cell-style="tableHeader"
            v-loading="loadingTable"
            element-loading-text="拼命加载中请稍后..."
            element-loading-spinner="el-icon-loading">
            <el-table-column  show-overflow-tooltip prop="suName" label="供应商名称"></el-table-column>
            <el-table-column  show-overflow-tooltip prop="staffUsename" label="联系人"></el-table-column>
            <el-table-column  show-overflow-tooltip prop="staffPhone" label="联系电话"></el-table-column>
            <el-table-column  show-overflow-tooltip prop="staffMobilePhone" label="联系手机"></el-table-column>
            <el-table-column  show-overflow-tooltip prop="suProvince" label="经营地址"></el-table-column>
            <el-table-column  show-overflow-tooltip prop="suAddress" label="详细地址"></el-table-column>
        </el-table>
        <span slot="footer">
            <el-button type="primary" @click="onSubmit">确 定</el-button>
            <el-button @click="disableDialog = false">取 消</el-button>
        </span>
    <!-------------- 添加供应商 -------------->
    <add-supplier-dialog

      @addSupplier="addSupplier"
      @addSupplierCallAll="addSupplierCallAll"
      ref="addSupplierDialogRefs"
    ></add-supplier-dialog>
    </el-dialog>

</template>
<script>
import addSupplierDialog from './addSupplierDialog'

import { queryAllSupplierBase } from '@/api/purchase/purchasePlanList'

export default {
  components: {
    'add-supplier-dialog': addSupplierDialog

  },
  directives: {
    'el-table-loadmore': {
      bind (el, binding) {
        // 获取element-ui定义好的scroll盒子
        const SELECTWRAP_DOM = el.querySelector(
          '.el-table .el-table__body-wrapper'
        )
        SELECTWRAP_DOM.addEventListener('scroll', function () {
          /**
           * scrollHeight 获取元素内容高度(只读)
           * scrollTop 获取或者设置元素的偏移值,常用于, 计算滚动条的位置, 当一个元素的容器没有产生垂直方向的滚动条, 那它的scrollTop的值默认为0.
           * clientHeight 读取元素的可见高度(只读)
           * 如果元素滚动到底, 下面等式返回true, 没有则返回false:
           * ele.scrollHeight - ele.scrollTop === ele.clientHeight;
           */
          const condition =
            this.scrollHeight - this.scrollTop <= this.clientHeight
          if (condition) {
            binding.value()
          }
        })
      }
    }
  },
  data () {
    return {
      queryParams: {},
      params: {},
      page: 1,
      message: {}, // 选中的
      size: 30,
      disableDialog: false,
      waitFeedbackEnquiryList: [
        { label: '供应商名称', value: 'suName' },
        { label: '联系人', value: 'staffUsename' },
        { label: '联系电话', value: 'staffPhone' },
        { label: '联系手机', value: 'staffMobilePhone' }], // 筛选条件
      loadingTable: false,
      list: []
    }
  },
  mounted () {
    this.mountTable()
  },
  methods: {
    addSupplierCallAll () {

    },
    addSupplier () {
      this.page = 1
      this.size = 30
      this.mountTable()
    },
    // 选中
    handleCurrentChange (val) {
      this.message = val
    },
    // 搜索
    searchFor () {
      this.mountTable(true)
    },
    // 重置
    searchReset () {
      this.params = {}
      this.mountTable()
    },
    // 滚动加载更多
    loadmore () {
      this.page++
      this.mountTable(false)

      // this.getSupplierList(this.currentPage)
    },
    // 供应商调用初始化
    onInitial () {
      this.page = 1
      this.size = 30
      this.mountTable()
      this.disableDialog = true
    },
    // 表格
    mountTable (status) {
      if (status === true) {
        this.list = []
        this.page = 1
      }

      const params = {
        criteriaVoList: [this.params],
        queryPageName: ''
      }
      queryAllSupplierBase(this.page, this.size, params).then(res => {
        if (res.data.code === 200) {
          if (this.page === 1) {
            this.list = res.data.obj.records
          } else {
            const arrList = res.data.obj.records
            this.list = this.list.concat(arrList)
          }
        }
      })
        .catch(err => {
          console.log(err)
        })
    },
    // 设置头部背景色
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    // 确定
    onSubmit () {
      if (this.message.suId === undefined) {
        this.$message.error('请选择供应商')
      } else {
        this.$emit('onAddSupplier', this.message)
        this.disableDialog = false
      }
    },
    // 添加供应商 111111这里有问题
    onAddSupplier () {
      console.log(1121)
      this.$refs.addSupplierDialogRefs.onInitial()
    }
  }
}
</script>
